import React, { useState, useRef, useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './RichTextEditor.css';

const RichTextEditor = ({ 
  initialContent = '', 
  onSave, 
  onCancel, 
  title = '', 
  onTitleChange,
  isEditing = false 
}) => {
  const [content, setContent] = useState(initialContent || '');
  const [currentTitle, setCurrentTitle] = useState(title || '');
  const quillRef = useRef(null);

  const handleSave = () => {
    onSave({
      title: currentTitle,
      content: content,
      excerpt: generateExcerpt(content)
    });
  };

  const generateExcerpt = (htmlContent) => {
    // Ensure htmlContent is a string
    if (!htmlContent || typeof htmlContent !== 'string') {
      return '';
    }
    // Strip HTML tags and get first 150 characters
    const textContent = htmlContent.replace(/<[^>]*>/g, '');
    return textContent.length > 150 ? textContent.substring(0, 150) + '...' : textContent;
  };

  const handleTitleChange = (e) => {
    const newTitle = e.target.value;
    setCurrentTitle(newTitle);
    if (onTitleChange) {
      onTitleChange(newTitle);
    }
  };

  const modules = useMemo(() => ({
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'align': [] }],
      ['link', 'image'],
      ['clean']
    ],
  }), []);

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'list', 'bullet', 'indent',
    'align', 'link', 'image'
  ];

  const getWordCount = () => {
    if (!content || typeof content !== 'string') return 0;
    const textContent = content.replace(/<[^>]*>/g, '');
    return textContent.trim().split(/\s+/).filter(word => word.length > 0).length;
  };

  return (
    <div className="rich-text-editor">
      <div className="editor-header">
        <div className="editor-title-section">
          <input
            type="text"
            value={currentTitle}
            onChange={handleTitleChange}
            placeholder="Enter blog post title..."
            className="editor-title-input"
          />
        </div>
        <div className="editor-actions">
          <button onClick={onCancel} className="btn btn-secondary">
            Cancel
          </button>
          <button onClick={handleSave} className="btn btn-primary">
            {isEditing ? 'Update Post' : 'Save Post'}
          </button>
        </div>
      </div>
      
      <div className="editor-content">
        <ReactQuill
          ref={quillRef}
          theme="snow"
          value={content}
          onChange={setContent}
          modules={modules}
          formats={formats}
          placeholder="Start writing your blog post..."
          style={{
            height: '500px',
            marginBottom: '50px'
          }}
        />
      </div>
      
      <div className="editor-footer">
        <div className="editor-info">
          <span>Word count: {getWordCount()}</span>
        </div>
      </div>
    </div>
  );
};

export default RichTextEditor;